import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Grid, MenuItem, Typography } from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import AttachPdfDialog from "../../../../commons/file/AttachPdfDialog";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../../../../commons/formik/FormikCheckbox";
import FormikDatePicker from "../../../../commons/formik/FormikDatePicker";
import FormikSelect from "../../../../commons/formik/FormikSelect";
import FormikTimePicker from "../../../../commons/formik/FormikTimePicker";
import { StyledABMNomina } from "../../../../styled/Personal";
import {
  datosNominalesValidation,
  validateRequiredFields,
} from "../validation/formValidation";

const DatosNominalesForm = ({
  handleSubmit,
  model,
  fields,
  handleCancelNomina,
  cantidadDiasIngresoFuturo,
  openAltaTempranaDialog,
  attachedFile,
  setAttachedFile,
  isAttachingFile,
  handleAttachFile,
  handleCancelAttachment
}) => {

  const [warningBajaMsg, setWarningBajaMsg] = useState(false);
  const [warningMsg, setWarningMsg] = useState(false);

  return (
    <Formik
      initialValues={model}
      onSubmit={handleSubmit}
      validationSchema={() => datosNominalesValidation(cantidadDiasIngresoFuturo)}
      validate={(values) => validateRequiredFields(values, fields)}
      validateOnBlur={true}
    >
      {({ setFieldValue, values }) => (
        <StyledABMNomina.FormContainer>
          <StyledABMNomina.GridContainer container spacing={9}>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikDatePicker
                id="fechaIngresoEmpleador"
                name="fechaIngresoEmpleador"
                label={`Fecha ingreso de la nómina ${
                  fields?.fechaIngresoEmpleador.obligatorio ? "*" : ""
                }`}
                fullWidth
                maxDaysFromToday={cantidadDiasIngresoFuturo}
              />
            </StyledABMNomina.InputContainer>
            <Grid item xs={2}>
              <FormikCheckbox
                id="agropecuario"
                name="agropecuario"
                label={`Agropecuario ${fields?.agropecuario.obligatorio ? "*" : ""
                  }`}
              />
            </Grid>
            <Grid item xs={2}>
              <FormikCheckbox
                id="domestica"
                name="domestica"
                label="Doméstica"
                callBack={(value) => {
                  if (!value) {
                    setFieldValue("categoriaDomestica", "");
                  }
                }}
              />
            </Grid>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikSelect
                fullWidth
                name="categoriaDomestica"
                label={`Categoría doméstica ${fields?.categoriaDomestica.obligatorio || values.domestica
                  ? "*"
                  : ""
                  }`}
                variant="standard"
                disabled={!values.domestica}
              >
                {fields?.categoriaDomestica.opciones.map(({ id, nombre }) => {
                  return (
                    <MenuItem value={id} key={id}>
                      {nombre}
                    </MenuItem>
                  );
                })}
              </FormikSelect>
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikCheckbox
                id="bajaNomina"
                name="bajaNomina"
                label="Baja nómina"
                callBack={(value) => {
                  if (!value) {
                    setFieldValue("fechaBaja", null);
                    setFieldValue("motivoBaja", "");
                  }
                  if (model.bajaNomina && !value) {
                    setWarningMsg(true);
                  } else if (!model.bajaNomina && value) {
                    setWarningBajaMsg(true);
                  } else {
                    setWarningBajaMsg(false);
                    setWarningMsg(false);
                  }
                }}
                disabled={fields.idTrabajador == 0}
              />
              {warningBajaMsg && (
                <div style={{ display: "flex" }}>
                  <WarningAmberIcon style={{ color: "#ebd80c" }} />
                  <Typography style={{ color: "#ebd80c" }}>
                    Está dando de baja la nómina
                  </Typography>
                </div>
              )}
              {warningMsg && (
                <div style={{ display: "flex" }}>
                  <WarningAmberIcon style={{ color: "#ebd80c" }} />
                  <Typography style={{ color: "#ebd80c" }}>
                    Está reactivando una nómina dada de baja
                  </Typography>
                </div>
              )}
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikDatePicker
                id="fechaBaja"
                name="fechaBaja"
                label={`Fecha baja de la nómina `}
                fullWidth
                disableFuture
                disabled={!values.bajaNomina}
              />
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikAutocomplete
                fullWidth
                name="motivoBaja"
                label={`Motivo baja `}
                variant="standard"
                options={fields?.motivoBaja.opciones}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
                disabled={!values.bajaNomina}
              />
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikDatePicker
                id="fechaIngresoDependencia"
                name="fechaIngresoDependencia"
                label={`Fecha ingreso de la dependencia ${fields?.fechaIngresoDependencia.obligatorio ? "*" : ""
                  }`}
                fullWidth
              />
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={8}>
              <FormikAutocomplete
                fullWidth
                disabled={model.establecimiento != ""}
                name="establecimiento"
                label={`Establecimiento ${fields?.establecimiento.obligatorio ? "*" : ""
                  }`}
                variant="standard"
                options={fields?.establecimiento.opciones}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
              />
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikAutocomplete
                fullWidth
                name="puestoTrabajo"
                label={`Puesto laboral ${fields?.puestoTrabajo.obligatorio ? "*" : ""
                  }`}
                variant="standard"
                options={fields?.puestoTrabajo.opciones}
                renderOption={(option) => option.nombre}
                filterOptions={(option) => option.nombre}
              />
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer item xs={4}>
              <FormikSelect
                fullWidth
                name="turno"
                label={`Turno ${fields?.turno.obligatorio ? "*" : ""}`}
                variant="standard"
              >
                {fields?.turno.opciones.map(({ id, nombre }) => {
                  return (
                    <MenuItem value={id} key={id}>
                      {nombre}
                    </MenuItem>
                  );
                })}
              </FormikSelect>
            </StyledABMNomina.InputContainer>
            <StyledABMNomina.InputContainer
              item
              xs={4}
              sx={{ position: "relative" }}
            >
              <Typography
                style={{
                  position: "absolute",
                  top: "40px"
                }}
              >
                Horario Laboral:
              </Typography>
              <Grid
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "10px",
                }}
              >
                <FormikTimePicker
                  name="horaDesde"
                  label={`Hora desde ${fields?.horaDesde.obligatorio ? "*" : ""
                    }`}
                  autoComplete="off"
                />
                <FormikTimePicker
                  name="horaHasta"
                  label={`Hora hasta ${fields?.horaHasta.obligatorio ? "*" : ""
                    }`}
                  autoComplete="off"
                />
              </Grid>
            </StyledABMNomina.InputContainer>
          </StyledABMNomina.GridContainer>
          <StyledABMNomina.ButtonContainer>
            <FormikActions submit="Guardar" handleCancel={handleCancelNomina} />
            </StyledABMNomina.ButtonContainer>
          <AttachPdfDialog
            open={openAltaTempranaDialog}
            onClose={handleCancelAttachment}
            title="ALTA TRABAJADOR ARCA"
            text="La fecha de ingreso indicada es posterior a la fecha actual. Se trata de un alta de nomina anticipada, por lo cual debe adjuntar el alta temprana de ARCA."
            file={attachedFile}
            setFile={setAttachedFile}
            isAttaching={isAttachingFile}
            handleCancelClick={handleCancelAttachment}
            handleConfirmClick={handleAttachFile}
            isConfirmButtonDisabled={!attachedFile}
            />
        </StyledABMNomina.FormContainer>
      )}
    </Formik>
  );
};

export default DatosNominalesForm;
